import "../../Sass/app.scss";
import React from "react";
import { NavLink } from "react-router-dom";

type pDashBoardCard = {
  title: string;
  count: number;
  link: string;
  upload?: string;
  image: any;
};

function DashBoardCard(props: pDashBoardCard) {
  const { title, count, link, upload, image } = props;

  return (
    // <section className="col-xl-3 col-md-4 mb-5">
    //   {/* Note: This main card should also be an article if it had an identifier like, a h tag */}
    //   <div className="card border-left-primary shadow h-120px py-4 p-3">
    //     <article className="card-body">
    //       <header className="mb-4">
    //         <div className="row justify-content-between">
    //           <img src={image} className="style" alt="Graphics Icon" />
    //           <br />
    //           <h5 className="card-title"> {title} </h5>
    //         </div>

    //         <h6 className="card-subtitle md-2 text-muted">count: {count}</h6>
    //       </header>

    //       <nav className="row justify-content-between">
    //         <NavLink
    //           className="btn btn-outline-primary card-link col-md-4"
    //           to={`/${link}`}
    //         >
    //           View
    //         </NavLink>

    //         {/* <NavLink className="btn btn-primary col-md-4" to={`/${upload}`}>
    //             Upload
    //           </NavLink> */}
    //       </nav>
    //     </article>
    //   </div>
    // </section>

    <NavLink className="block" to={`/${link}`}>
      <div className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition-shadow duration-200">
        <img src={image} className="style" alt="Graphics Icon" />
        <div className="text-gray-500 text-sm mb-2">{title}</div>
        <div className="text-3xl font-bold text-gray-800">{count}</div>
        <div className="text-blue-600 mt-2 text-sm">View→</div>
      </div>
    </NavLink>
  );
}

export default DashBoardCard;
